import React from 'react';
import { CgChevronRight } from 'react-icons/cg';
// ICONS
import Link from '@components/Link';
import { FiExternalLink } from 'react-icons/fi';

import Text from '../Text/Text';
import Title from '../Title/Title';
import './Item.scss';

interface Props {
    title: string;
    subtitle?: string | React.ReactNode;
    href?: string;
    to?: string;
    button?: boolean;
    onClick?: (e: any) => void;
    startSlot?: any;
    endSlot?: any;
    size?: 's' | 'm' | 'l';
    variant?: 'danger' | 'outline';
    theme?: 'warning';
    className?: string;
    children?: React.ReactNode;
    disabled?: boolean;
}

const Item: React.FC<Props> = ({
    title,
    subtitle,
    href,
    to,
    button,
    onClick,
    startSlot,
    endSlot,
    variant,
    size = 'm',
    children,
    className,
    theme,
    disabled = false,
}) => {
    const modifylClass = [
        'Item',
        className ? className : '',
        size !== undefined ? 'size-' + size : '',
        variant !== undefined ? 'variant-' + variant : '',
        theme ? 'theme-' + theme : '',
        disabled ? 'is-disabled' : '',
    ]
        .join(' ')
        .replace(/\s{2,}/g, ' ');

    function renderInSlot(content: any) {
        return <span className="Item--slot">{content}</span>;
    }

    function renderEndSlot() {
        if (endSlot) {
            return renderInSlot(endSlot);
        } else if (button || to) {
            return renderInSlot(
                <span className="Item--arrowIcon">
                    <CgChevronRight />
                </span>
            );
        } else if (href) {
            return renderInSlot(
                <span className="Item--exitIcon">
                    <FiExternalLink />
                </span>
            );
        } else {
            return;
        }
    }

    function renderInnerContent() {
        return (
            <>
                {startSlot && (
                    <span className="Item--slot Item--slot-start">
                        {startSlot}
                    </span>
                )}
                <span className="Item--slot Item--content">
                    <Title tag="span" size="s" noMargin>
                        {title}
                    </Title>
                    {subtitle && (
                        <>
                            {typeof subtitle === 'string' ? (
                                <Text size="xxs" tag="span">
                                    {subtitle}
                                </Text>
                            ) : (
                                subtitle
                            )}
                        </>
                    )}
                </span>
                {children}
                {renderEndSlot()}
            </>
        );
    }

    function renderFullComponent() {
        if (button) {
            return (
                <button className={modifylClass} onClick={onClick}>
                    {renderInnerContent()}
                </button>
            );
        } else if (href) {
            return (
                <a
                    onClick={onClick}
                    href={href}
                    className={modifylClass}
                    target="_blank"
                    rel="noreferrer"
                >
                    {renderInnerContent()}
                </a>
            );
        } else if (to) {
            return (
                <Link to={to} className={modifylClass}>
                    {renderInnerContent()}
                </Link>
            );
        } else {
            return <div className={modifylClass}>{renderInnerContent()}</div>;
        }
    }

    return renderFullComponent();
};

export default Item;
